export const resolvePhcUploadPortfolioId = (response) => {
  if (!response) {
    return null;
  }

  const nested = response.result ?? response.response ?? response.data ?? response;

  const candidates = [
    nested?.portfolioId,
    response?.portfolioId,
    response?.result?.portfolioId,
    nested?.id,
    response?.id,
  ];

  const portfolioId = candidates.find(
    (id) => id !== null && id !== undefined && id !== "",
  );

  return portfolioId ?? null;
};
